export const getId = (): string => Math.random().toString(36).slice(0, 5)
